import { inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { FORMATTED_VALUE_FALLBACK, formatCount } from '../utils/formatted-value-formatter.function';

@Pipe({
  name: 'formattedCount',
  standalone: true,
})
export class FormattedCountPipe implements PipeTransform {
  private readonly locale = inject(LOCALE_ID);

  public transform(value: unknown, fallback = FORMATTED_VALUE_FALLBACK): string {
    return formatCount(value, this.locale, fallback);
  }
}
